import { render, staticRenderFns } from "./CollectionPayCertificateInstallment2.vue?vue&type=template&id=6778a3e4&scoped=true"
import script from "./CollectionPayCertificateInstallment2.vue?vue&type=script&lang=js"
export * from "./CollectionPayCertificateInstallment2.vue?vue&type=script&lang=js"
import style0 from "./CollectionPayCertificateInstallment2.vue?vue&type=style&index=0&id=6778a3e4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6778a3e4",
  null
  
)

export default component.exports